/**
 * Returns a encoded version of the filename in a URL, leaving the URL otherwise untouched
 * @param {string} url
 * @returns {string}
 */
export const encodeRemoteFileName = url => url
